<template>
  <el-dialog
    :title="$t('labelManage.deleteTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{ $t('labelManage.deleteConfirm') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteLabel">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteLabel } from '@/api/goods/labelApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteLabel',
  data() {
    return {
      dialogVisible: false,
      deleteLabelInfo: {
        labelId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteLabelInfo.labelId = row.labelId
    },
    handleClose() {
      this.deleteLabelInfo = {
        labelId: '',
        shopId: ''
      }
    },
    async deleteLabel() {
      let shopId = getShopId()
      this.deleteLabelInfo.shopId = shopId
      try {
        await deleteLabel(this.deleteLabelInfo)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('删除标签失败:', error)
      }
    }
  }
}
</script>